import gql from 'graphql-tag';

export const registerUser = gql`
  mutation registerUser($input: RegisterUserInput!) {
    registerUser(input: $input) {
      id
    }
  }
`;
